const _ = require('lodash');
const { gatewayType } = require('./gateways/gatewayMapper');
const { apmType } = require('./apms/apmsMapper');
const currencyTools = require('./currencies');

function mapType(typeNumber, types) {
    if (typeNumber >= types.length || typeNumber < 0) {
        return 'Unknown';
    } else {
        return types[typeNumber];
    }
}

const cycleTypes = ['0th: Canceled', '1st: Initial', '2nd: Won', '3rd: Represent', '4th: Final'];

let currency = currencyTools.currency;

function addToAllCurrencies(gatewayTypeArray, currencyArray) {
    _.forEach(Object.keys(currencyArray), (key) => {
        currencyArray[key] = _.concat(currencyArray[key], gatewayTypeArray);
    });
    return currencyArray;
}

function invertObjectWithArrayValues(object) {
    return Object.keys(object).reduce((acc, itemKey) => {
        let value = object[itemKey];
        value = _.isArray(value) ? value : [value];

        const invertedItems = value.map((objectValue) => {
            return { [objectValue]: itemKey };
        });

        return _.mergeWith(acc, ...invertedItems, (targetValue, sourceValue) => {
            targetValue = !_.isArray(targetValue) ? [targetValue] : targetValue;
            sourceValue = !_.isArray(sourceValue) ? [sourceValue] : sourceValue;

            return _.compact([...targetValue, ...sourceValue]);
        });
    }, {});
}

const accountUpdaterModes = {
    create: 10,
    update: 20,
    delete: 30
};

const accountUpdaterModesMapper = _.invert(accountUpdaterModes);

const chargebackCycleTypes = {
    canceled: 0,
    new: 1,
    won: 2,
    representment: 3,
    final: 4
};

const chargebackCycleTypesMapper = _.invert(chargebackCycleTypes);

const cardTypes = {
    visa: 10,
    mastercard: 20,
    discover: 30,
    amex: 40,
    jcb: 50
};

const cardClasses = {
    credit: 1,
    debit: 2,
    chargeCard: 3,
    unknown: 4
};

const cardClassesMapper = _.invert(cardClasses);

const cardTypesMapper = _.invert(cardTypes);

const merchantProcessorType = {
    fdr: 10,
    tsys: 20,
    payvision: 30
};

const merchantProcessorTypeMapper = _.invert(merchantProcessorType);

const threeDSType = {
    aci: 10,
    switch: 20,
    payments_os: 30,
    payments_os_turkey: 31,
    payments_os_south_africa: 32,
    payments_os_russia: 33,
    payments_os_nigeria: 34,
    payments_os_india: 35,
    payments_os_iyzico: 36,
    cybersource: 40,
    cardinalCommerce: 50,
    stripe: 60
};

const threeDSTypeMapper = _.invert(threeDSType);

const processorPrefixes = [
    {
        merchantIdPrefix: 513485,
        id: merchantProcessorType.fdr
    }, {
        merchantIdPrefix: 515794,
        id: merchantProcessorType.fdr
    }, {
        merchantIdPrefix: 543093,
        id: merchantProcessorType.fdr
    }, {
        merchantIdPrefix: 9235,
        id: merchantProcessorType.tsys
    }, {
        merchantIdPrefix: 9236,
        id: merchantProcessorType.tsys
    }, {
        merchantIdPrefix: 9289,
        id: merchantProcessorType.tsys
    }, {
        merchantIdPrefix: 111,
        id: merchantProcessorType.payvision
    }
];

function findProcessorWithMatchingPrefix(mid = '') {
    const processor = processorPrefixes.find((processor) => {
        let prefix = _.get(processor, 'merchantIdPrefix', '');

        return _.startsWith(mid, prefix);
    });

    return _.get(processor, 'id');
}

const processorsWithDisputeEnabled = [merchantProcessorType.fdr, merchantProcessorType.tsys];

// Deprecated - should be moved to use SuperApp, its the only place it is used.
const paymentMethodsFormatted = {
    10: 'Credit Card',
    40: 'eCheck',
    50: 'Credit'
};

// There are jumps in the values do to removing unused values. Feel free to use 30 and 50
const processMethod = {
    card: 10,
    cardPresent: 11,
    cardNotPresent: 12,
    apm: 20,
    eCheck: 40,
    credit: 50,
    cash: 60,
    cardPayout: 70,
    eCheckPayout: 80
};

const processMethodMapper = _.invert(processMethod);

const installmentProviders = {
    payPal: apmType.payPal,
    klarna: apmType.klarnaCheckout
};

const installmentProvidersMapper = _.invert(installmentProviders);

const transactionStatus = {
    authorized: 10,
    authorizedPending: 9,
    authOnly: 11,
    authOnlyPending: 3,
    pending: 12,
    submitted: 13,
    settled: 20,
    declined: 30,
    riskHold: 31,
    fraudReject: 32,
    rejected: 33,
    voided: 40,
    voidPending: 39,
    error: 50
};

const transactionStatusMapper = _.invert(transactionStatus);

const paymentStatusToTransactionStatus = {
    authOnly: transactionStatus.authOnly,
    authOnlyPending: transactionStatus.authOnlyPending,
    authorizedPending: transactionStatus.authorizedPending,
    declined: transactionStatus.declined,
    error: transactionStatus.error,
    pending: transactionStatus.authorized,
    settled: transactionStatus.settled,
    voided: transactionStatus.voided,
    voidPending: transactionStatus.voidPending
};

const transactionType = {
    sale: 10,
    refund: 20,
    payout: 30
};

const transactionTypeMapper = _.invert(transactionType);

const pluginType = {
    slyce: 10,
    emvio: 20
};

const pluginTypeMapper = _.invert(pluginType);

const batchStatus = {
    open: 10,
    closed: 20,
    rejected: 30
};

const batchStatusMapper = _.invert(batchStatus);

const achDetailType = {
    batch: 10,
    adjustment: 20,
    chargeback: 30,
    fees: 40,
    reserve: 50,
    reserveHeld: 51,
    reserveRelease: 52,
    split: 60
};

const achDetailTypeMapper = _.invert(achDetailType);

const kountThresholds = {
    billingAddressDeliverableDecline: 'Decline the transaction if the Billing Address is not deliverable.',
    billingAddressDeliverableReview: 'Mark the transaction for Review if the Billing Address is not deliverable.',
    billingToShippingAddressDecline: 'Decline the transaction if the Billing to Shipping distance(in kilometers) exceeds the value specified.',
    billingToShippingAddressReview: 'Mark the transaction for Review if the Device IP to Shipping distance(in kilometers) exceeds the value specified.',
    billShipAddressNotMatchDecline: 'Decline the transaction if the Billing and Shipping Address provided by the customer are not an exact match.',
    billShipAddressNotMatchReview: 'Mark the transaction for Review if the Billing and Shipping Address provided by the customer are not an exact match.',
    blacklistAvsStreetResponseDecline: 'Decline the transaction if the AVS Street Authorization Response matches any of the values selected.',
    blacklistAvsStreetResponseReview: 'Mark the transaction for Review if the AVS Street Authorization Response matches any of the values selected.',
    blacklistAvsZipResponseDecline: 'Decline the transaction if the AVS Zip Authorization Response matches any of the values selected.',
    blacklistAvsZipResponseReview: 'Mark the transaction for Review if the AVS Zip Authorization Response matches any of the values selected.',
    blacklistCvvResponseDecline: 'Decline the transaction if the CVV Authorization Response matches any of the values selected.',
    blacklistCvvResponseReview: 'Mark the transaction for Review if the CVV Authorization Response matches any of the values selected.',
    blacklistIpCountryDecline: 'Decline the transaction if the Device IP Country matches any of the values selected.',
    blacklistIpCountryReview: 'Mark the transaction for Review if the Device IP Country matches any of the values selected.',
    blacklistNetworkTypeDecline: 'Decline the transaction if the Network Type matches any of the values selected.',
    blacklistNetworkTypeReview: 'Mark the transaction for Review if the Network Type matches any of the values selected.',
    blacklistPaymentCountryDecline: 'Decline the transaction if the BIN Country matches any of the values selected. Note, BIN Country is only available when Credit Cards are used for the transaction.',
    blacklistPaymentCountryReview: 'Mark the transaction for Review if the BIN Country matches any of the values selected. Note, BIN Country is only available when Credit Cards are used for the transaction.',
    blacklistShippingCountryDecline: 'Decline the transaction if the Shipping Address Country matches any of the values selected.',
    blacklistShippingCountryReview: 'Mark the transaction for Review if the Shipping Address Country matches any of the values selected.',
    cardPtokAuthAVelocityDecline: 'Decline the transaction if the number of transactions with the same Credit Card and bank auth was approved in the last hour exceeds the value specified.',
    cardPtokAuthAVelocityReview: 'Review the transaction if the number of transactions with the same Credit Card and bank auth was approved in the last hour exceeds the value specified.',
    cardPtokAuthDVelocityDecline: 'Decline the transaction if the number of transactions with the same Credit Card and bank auth was declined in the last hour exceeds the value specified.',
    cardPtokAuthDVelocityReview: 'Review the transaction if the number of transactions with the same Credit Card and bank auth was declined in the last hour exceeds the value specified.',
    cardPtokVelocityDecline: 'Decline the transaction if the number of transactions with the same Credit Card in the last hour exceeds the value specified.',
    cardPtokVelocityReview: 'Mark the transaction for Review if the number of transactions with the same Credit Card in the last hour exceeds the value specified.',
    deviceFingerprintAuthAVelocityDecline: 'Decline the transaction if the number of transactions with the same Device Fingerprint in the last hour exceeds the value specified, and the bank auth was approved.',
    deviceFingerprintAuthAVelocityReview: 'Review the transaction if the number of transactions with the same Device Fingerprint in the last hour exceeds the value specified, and the bank auth was approved.',
    deviceFingerprintAuthDVelocityDecline: 'Decline the transaction if the number of transactions with the same Device Fingerprint in the last hour exceeds the value specified, and the bank auth was declined.',
    deviceFingerprintAuthDVelocityReview: 'Review the transaction if the number of transactions with the same Device Fingerprint in the last hour exceeds the value specified, and the bank auth was declined.',
    deviceFingerprintVelocityDecline: 'Decline the transaction if the number of transactions with the same Device Fingerprint in the last hour exceeds the value specified.',
    deviceFingerprintVelocityReview: 'Mark the transaction for Review if the number of transactions with the same Device Fingerprint in the last hour exceeds the value specified.',
    deviceIpVelocityDecline: 'Decline the transaction if the number of transactions with the same Device IP in the last hour exceeds the value specified.',
    deviceIpVelocityReview: 'Mark the transaction for Review if the number of transactions with the same Device IP in the last hour exceeds the value specified.',
    deviceToBillingAddressDecline: 'Decline the transaction if the Device IP to Billing distance(in kilometers) exceeds the value specified.',
    deviceToBillingAddressReview: 'Mark the transaction for Review if the Device IP to Billing distance(in kilometers) exceeds the value specified.',
    deviceToShippingAddressDecline: 'Decline the transaction if the Device IP to Shipping distance(in kilometers) exceeds the value specified.',
    deviceToShippingAddressReview: 'Mark the transaction for Review if the Device IP to Billing distance(in kilometers) exceeds the value specified.',
    emailCalendarDayVeloDecline: 'Decline the transaction if the number of transactions with the same Billing Email Address during the same calendar day exceeds the value specified.',
    emailCalendarDayVeloReview: 'Mark the transaction for Review if the number of transactions with the same Billing Email Address during the same calendar day exceeds the value specified.',
    emailVelocityDecline: 'Decline the transaction if the number of transactions with the same Billing Email Address in the last 24 hours exceeds the value specified.',
    emailVelocityReview: 'Mark the transaction for Review if the number of transactions with the same Billing Email Address in the last 24 hours exceeds the value specified.',
    highRiskDecline: 'Decline the transaction if the Fraud Risk is High.',
    highRiskReview: 'Mark the transaction for Review if the Fraud Risk is High.',
    invalidBillingPhoneDecline: 'Decline transaction if the billing phone number has no directory match',
    invalidBillingPhoneReview: 'Review transaction if the billing phone number has no directory match',
    mediumRiskReview: 'Mark the transaction for Review if the Fraud Risk is Medium.',
    orderTotalDecline: 'Decline the transaction if the Order Total Amount (in fractional base currency, i.e. pennies) exceeds the value specified.',
    orderTotalReview: 'Mark the transaction for Review if the Order Total Amount (in fractional base currency, i.e. pennies) exceeds the value specified.',
    paymentCountryDeviceCountryNotMatchDecline: 'Mark the transaction for Decline if the payment country and the device country are not an exact match.',
    paymentCountryDeviceCountryNotMatchReview: 'Mark the transaction for Review if the payment country and the device country are not an exact match.',
    paymentCountryIpCountryNotMatchDecline: 'Mark the transaction for Decline if the payment country and the IP country are not an exact match.',
    paymentCountryIpCountryNotMatchReview: 'Mark the transaction for Review if the payment country and the IP country are not an exact match.',
    riskScoreDecline: 'Decline the transaction if the Fraud Score is higher than value specified.',
    riskScoreReview: 'Mark the transaction for Review if the Fraud Score is higher than value specified.',
    shippingAddressDeliverableDecline: 'Decline the transaction if the Shipping Address is not deliverable.',
    shippingAddressDeliverableReview: 'Mark the transaction for Review if the Shipping Address is not deliverable.',
    suspectIpDecline: 'Decline based on device IP being on a global suspect list',
    suspectIpReview: 'Review based on device IP being on a global suspect list',
    transactionVelocityDecline: 'Decline the transaction if the number of transactions in the last 24 hours exceeds the value specified.',
    transactionVelocityReview: 'Mark the transaction for Review if the number of transactions in the last 24 hours exceeds the value specified.',
    universalChargebackCardDecline: 'Decline based on whether a card was found on the chargeback list',
    universalChargebackCardReview: 'Review based on whether a card was found on the chargeback list'
};

const paymentMethodToGateway = {
    [processMethod.card]: [
        gatewayType.usaepay,
        gatewayType.nexio,
        gatewayType.nexio_auto,
        gatewayType.nexio_async,
        gatewayType.nmi,
        gatewayType.nmi_card_vault,
        gatewayType.nmi_auto,
        gatewayType.acapture,
        gatewayType.aci_auto,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.authorize,
        gatewayType.zeamster,
        gatewayType.reach,
        gatewayType.switch,
        gatewayType.switch_kicc,
        gatewayType.switch_cardnet,
        gatewayType.openpay,
        gatewayType.payments_os,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_turkey,
        gatewayType.payments_os_south_africa,
        gatewayType.payments_os_colombia,
        gatewayType.payments_os_russia,
        gatewayType.payments_os_nigeria,
        gatewayType.payments_os_india,
        gatewayType.payments_os_iyzico,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.kushki,
        gatewayType.kushki_ecuador,
        gatewayType.propay,
        gatewayType.propay_canada,
        gatewayType.trust_my_travel,
        gatewayType.cybersource,
        gatewayType.powercash,
        gatewayType.emerchantpay,
        gatewayType.adyen,
        gatewayType.place_to_pay,
        gatewayType.bambora,
        gatewayType.ntt_cybersource
    ],
    [processMethod.eCheck]: [
        gatewayType.nexio,
        gatewayType.nmi,
        gatewayType.usaepay
    ],
    [processMethod.credit]: [
        gatewayType.usaepay,
        gatewayType.nmi,
        gatewayType.nmi_auto,
        gatewayType.propay_canada
    ],
    [processMethod.cardPayout]: [
        gatewayType.checkout
    ],
    [processMethod.eCheckPayout]: [
        gatewayType.checkout
    ]
};

const gatewayToPaymentMethodMapper = invertObjectWithArrayValues(paymentMethodToGateway);

const currencyToGateway = addToAllCurrencies([
    gatewayType.nexio,
    gatewayType.nexio_auto,
    gatewayType.nexio_async,
    gatewayType.emerchantpay,
    gatewayType.place_to_pay,
    gatewayType.ntt_cybersource
], {
    [currency.usd.id]: [
        gatewayType.usaepay,
        gatewayType.nmi,
        gatewayType.nmi_card_vault,
        gatewayType.nmi_auto,
        gatewayType.acapture,
        gatewayType.aci_auto,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.authorize,
        gatewayType.zeamster,
        gatewayType.reach,
        gatewayType.switch,
        gatewayType.payments_os_colombia,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_nigeria,
        gatewayType.payments_os_india,
        gatewayType.payments_os_iyzico,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.kushki,
        gatewayType.kushki_ecuador,
        gatewayType.propay,
        gatewayType.cybersource,
        gatewayType.powercash,
        gatewayType.trust_my_travel,
        gatewayType.adyen,
        gatewayType.bambora
    ],
    [currency.gbp.id]: [
        gatewayType.usaepay,
        gatewayType.acapture,
        gatewayType.nmi,
        gatewayType.nmi_card_vault,
        gatewayType.nmi_auto,
        gatewayType.aci_auto,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.payments_os_iyzico,
        gatewayType.authorize,
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.cny.id]: [
        gatewayType.acapture,
        gatewayType.aci_auto,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.jpy.id]: [
        gatewayType.acapture,
        gatewayType.aci_auto,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.adyen,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.nmi,
        gatewayType.nmi_auto,
        gatewayType.nmi_card_vault,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.usaepay
    ],
    [currency.eur.id]: [
        gatewayType.usaepay,
        gatewayType.nmi,
        gatewayType.nmi_auto,
        gatewayType.acapture,
        gatewayType.aci_auto,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.authorize,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.payments_os_iyzico,
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.powercash,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.cad.id]: [
        gatewayType.usaepay,
        gatewayType.nmi,
        gatewayType.nmi_auto,
        gatewayType.acapture,
        gatewayType.aci_auto,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.authorize,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.propay_canada,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen,
        gatewayType.bambora
    ],
    [currency.aud.id]: [
        gatewayType.acapture,
        gatewayType.aci_auto,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.adyen,
        gatewayType.authorize,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.reach,
        gatewayType.nmi,
        gatewayType.nmi_auto,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.usaepay
    ],
    [currency.mxn.id]: [
        gatewayType.acapture,
        gatewayType.aci_auto,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.adyen,
        gatewayType.reach,
        gatewayType.switch,
        gatewayType.switch_kicc,
        gatewayType.openpay,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.usaepay
    ],
    [currency.krw.id]: [
        gatewayType.acapture,
        gatewayType.aci_auto,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.reach,
        gatewayType.switch,
        gatewayType.switch_kicc,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.usaepay,
        gatewayType.adyen
    ],
    [currency.brl.id]: [
        gatewayType.acapture,
        gatewayType.aci_auto,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.hnl.id]: [
        gatewayType.acapture,
        gatewayType.aci_auto,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.nmi,
        gatewayType.nmi_auto,
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.trust_my_travel
    ],
    [currency.php.id]: [
        gatewayType.acapture,
        gatewayType.aci_auto,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.reach,
        gatewayType.switch,
        gatewayType.switch_kicc,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.zmw.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.zar.id]: [
        gatewayType.reach,
        gatewayType.switch,
        gatewayType.payments_os,
        gatewayType.payments_os_south_africa,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.adyen,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.usaepay
    ],
    [currency.yer.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.xpf.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.xof.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.xcd.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.xaf.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.trust_my_travel
    ],
    [currency.wst.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.vuv.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.vnd.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.uzs.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.uyu.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.ugx.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.uah.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.usaepay
    ],
    [currency.tzs.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.twd.id]: [
        gatewayType.reach,
        gatewayType.switch,
        gatewayType.switch_kicc,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.stripe,
        gatewayType.nmi,
        gatewayType.nmi_auto,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.ttd.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.try.id]: [
        gatewayType.reach,
        gatewayType.switch,
        gatewayType.switch_kicc,
        gatewayType.payments_os,
        gatewayType.payments_os_turkey,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_iyzico,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.top.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.tnd.id]: [
        gatewayType.reach,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.thb.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.stripe,
        gatewayType.nmi,
        gatewayType.nmi_auto,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.szl.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.stn.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.cybersource
    ],
    [currency.sos.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.sll.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.shp.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.sgd.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.sek.id]: [
        gatewayType.authorize,
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.scr.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.sbd.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.rwf.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.rub.id]: [
        gatewayType.reach,
        gatewayType.switch,
        gatewayType.switch_kicc,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.stripe,
        gatewayType.payments_os_russia,
        gatewayType.payments_os_iyzico,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.rsd.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.qar.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.pyg.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.pln.id]: [
        gatewayType.nmi,
        gatewayType.nmi_auto,
        gatewayType.authorize,
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.pkr.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.pgk.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.pen.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.pab.id]: [
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.nmi,
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.trust_my_travel
    ],
    [currency.omr.id]: [
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.reach,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.nzd.id]: [
        gatewayType.authorize,
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.npr.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.payments_os_india,
        gatewayType.trust_my_travel
    ],
    [currency.nok.id]: [
        gatewayType.authorize,
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.payments_os_iyzico,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.nio.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.ngn.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.payments_os_nigeria
    ],
    [currency.myr.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.stripe,
        gatewayType.nmi,
        gatewayType.nmi_auto,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.mwk.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.mvr.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.payments_os_asia_pacific,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.mur.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.payments_os_india,
        gatewayType.trust_my_travel
    ],
    [currency.mru.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.cybersource
    ],
    [currency.mop.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.mnt.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.mdl.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.mad.id]: [
        gatewayType.aci_planet,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.payments_os_asia_pacific,
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.trust_my_travel
    ],
    [currency.lyd.id]: [
        gatewayType.reach,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.lkr.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.payments_os_india,
        gatewayType.trust_my_travel
    ],
    [currency.lbp.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.lak.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.kzt.id]: [
        gatewayType.reach,
        gatewayType.switch,
        gatewayType.switch_kicc,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.kyd.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.kwd.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.payments_os_asia_pacific,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.payments_os_india,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.kmf.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.kgs.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.kes.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.payments_os_india,
        gatewayType.trust_my_travel
    ],
    [currency.jod.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.jmd.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.isk.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.inr.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.ils.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.idr.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.payments_os_asia_pacific,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.huf.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.htg.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.hrk.id]: [
        gatewayType.payments_os_asia_pacific,
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.hkd.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen,
        gatewayType.nmi,
        gatewayType.nmi_auto
    ],
    [currency.gyd.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.gtq.id]: [
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.nmi,
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.trust_my_travel
    ],
    [currency.gnf.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.gmd.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.gip.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.ghs.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.gel.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.fkp.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.fjd.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.etb.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.egp.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.dzd.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.dop.id]: [
        gatewayType.reach,
        gatewayType.switch_cardnet,
        gatewayType.switch,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.usaepay
    ],
    [currency.dkk.id]: [
        gatewayType.authorize,
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.djf.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.czk.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.cve.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.crc.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.usaepay
    ],
    [currency.cop.id]: [
        gatewayType.reach,
        gatewayType.payments_os_colombia,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.usaepay
    ],
    [currency.clp.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.chf.id]: [
        gatewayType.authorize,
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.payments_os_iyzico,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.bzd.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.byn.id]: [
        gatewayType.reach,
        gatewayType.switch,
        gatewayType.switch_kicc,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.bwp.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.bsd.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.bob.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.bnd.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.bmd.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.bhd.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.bgn.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.bdt.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.payments_os_india,
        gatewayType.trust_my_travel
    ],
    [currency.bbd.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.bam.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.azn.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.awg.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.ars.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.aoa.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.ang.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.amd.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.all.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.ron.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.sar.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.adyen
    ],
    [currency.khr.id]: [
        gatewayType.reach,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.svc.id]: [
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.nmi,
        gatewayType.reach,
        gatewayType.trust_my_travel
    ],
    [currency.aed.id]: [
        gatewayType.reach,
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.payments_os_asia_pacific,
        gatewayType.payments_os_india,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel,
        gatewayType.usaepay,
        gatewayType.adyen
    ],
    [currency.mzn.id]: [
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.nad.id]: [
        gatewayType.aci_planet,
        gatewayType.aci_planet_mcp,
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.afn.id]: [
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.bif.id]: [
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.cdf.id]: [
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.lrd.id]: [
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.lsl.id]: [
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.mga.id]: [
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.mkd.id]: [
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.mmk.id]: [
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.srd.id]: [
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ],
    [currency.tjs.id]: [
        gatewayType.stripe,
        gatewayType.checkout,
        gatewayType.checkout_nas,
        gatewayType.cybersource,
        gatewayType.trust_my_travel
    ]
});

const gatewayToCurrencyMapper = invertObjectWithArrayValues(currencyToGateway);

const currencyToApm = {
    [currency.usd.id]: [
        apmType.googlePayAuthNet,
        apmType.applePayAuthNet,
        apmType.googlePayCyberSource,
        apmType.applePayCyberSource,
        apmType.payPal,
        apmType.nihaoPayAliPay,
        apmType.nihaoPayUnionPay,
        apmType.nihaoPayWechatPay,
        apmType.pproBitPay,
        apmType.klarnaCheckout,
        apmType.klarnaPayments,
        apmType.braintreePayPal,
        apmType.adyenKlarnaPayOverTime,
        apmType.adyenDropIn,
        apmType.adyenAfterPay
    ],
    [currency.gbp.id]: [
        apmType.googlePayAuthNet,
        apmType.payPal,
        apmType.nihaoPayAliPay,
        apmType.nihaoPayUnionPay,
        apmType.nihaoPayWechatPay,
        apmType.pproBitPay,
        apmType.klarnaCheckout,
        apmType.klarnaPayments,
        apmType.adyenTrustly,
        apmType.braintreePayPal,
        apmType.adyenKlarnaPayLater,
        apmType.adyenKlarnaPayOverTime,
        apmType.adyenDropIn,
        apmType.adyenSofort
    ],
    [currency.cny.id]: [apmType.nihaoPayAliPay, apmType.nihaoPayUnionPay, apmType.nihaoPayWechatPay],
    [currency.jpy.id]: [apmType.googlePayAuthNet, apmType.payPal, apmType.nihaoPayAliPay, apmType.nihaoPayUnionPay, apmType.nihaoPayWechatPay],
    [currency.eur.id]: [
        apmType.googlePayAuthNet,
        apmType.googlePayCyberSource,
        apmType.payPal,
        apmType.nihaoPayAliPay,
        apmType.nihaoPayUnionPay,
        apmType.nihaoPayWechatPay,
        apmType.pproIdeal,
        apmType.pproBitPay,
        apmType.pproEps,
        apmType.pproMultibanco,
        apmType.pproTrustPay,
        apmType.klarnaCheckout,
        apmType.klarnaPayments,
        apmType.adyenGiroPay,
        apmType.adyenSepa,
        apmType.adyenMobilePay,
        apmType.adyenIdeal,
        apmType.adyenTrustly,
        apmType.braintreePayPal,
        apmType.adyenSofort,
        apmType.adyenKlarnaPayOverTime,
        apmType.adyenKlarnaPayLater,
        apmType.adyenDropIn
    ],
    [currency.cad.id]: [
        apmType.googlePayAuthNet,
        apmType.applePayAuthNet,
        apmType.googlePayCyberSource,
        apmType.applePayCyberSource,
        apmType.payPal,
        apmType.nihaoPayAliPay,
        apmType.nihaoPayUnionPay,
        apmType.nihaoPayWechatPay,
        apmType.braintreePayPal,
        apmType.klarnaPayments,
        apmType.adyenAfterPay,
        apmType.adyenDropIn
    ],
    [currency.aud.id]: [
        apmType.payPal,
        apmType.googlePayCyberSource,
        apmType.applePayCyberSource,
        apmType.pproPoli,
        apmType.braintreePayPal,
        apmType.klarnaCheckout,
        apmType.klarnaPayments,
        apmType.adyenPoli,
        apmType.adyenAfterPay,
        apmType.adyenDropIn,
        apmType.adyenKlarnaPayOverTime
    ],
    [currency.mxn.id]: [apmType.payPal, apmType.paynet, apmType.openpaySpei, apmType.openpayCodi],
    [currency.krw.id]: [],
    [currency.brl.id]: [apmType.googlePayAuthNet, apmType.payPal],
    [currency.hnl.id]: [apmType.googlePayAuthNet],
    [currency.php.id]: [apmType.payPal],
    [currency.zmw.id]: [],
    [currency.zar.id]: [],
    [currency.yer.id]: [],
    [currency.xpf.id]: [],
    [currency.xof.id]: [],
    [currency.xcd.id]: [],
    [currency.xaf.id]: [],
    [currency.wst.id]: [],
    [currency.vuv.id]: [],
    [currency.vnd.id]: [],
    [currency.uzs.id]: [],
    [currency.uyu.id]: [],
    [currency.ugx.id]: [],
    [currency.uah.id]: [apmType.googlePayAuthNet],
    [currency.tzs.id]: [],
    [currency.twd.id]: [apmType.googlePayAuthNet, apmType.payPal],
    [currency.ttd.id]: [],
    [currency.try.id]: [],
    [currency.top.id]: [],
    [currency.tnd.id]: [],
    [currency.thb.id]: [apmType.payPal],
    [currency.szl.id]: [],
    [currency.stn.id]: [],
    [currency.sos.id]: [],
    [currency.sll.id]: [],
    [currency.shp.id]: [],
    [currency.sgd.id]: [apmType.googlePayAuthNet, apmType.payPal, apmType.pproGrabPay],
    [currency.sek.id]: [
        apmType.googlePayAuthNet,
        apmType.payPal,
        apmType.klarnaCheckout,
        apmType.klarnaPayments,
        apmType.adyenSwish,
        apmType.adyenMobilePay,
        apmType.adyenTrustly,
        apmType.adyenKlarnaPayOverTime,
        apmType.adyenKlarnaPayLater,
        apmType.adyenKlarnaPayOverTime,
        apmType.adyenDropIn
    ],
    [currency.scr.id]: [],
    [currency.sbd.id]: [],
    [currency.rwf.id]: [],
    [currency.rub.id]: [apmType.googlePayAuthNet, apmType.payPal],
    [currency.rsd.id]: [],
    [currency.qar.id]: [],
    [currency.pyg.id]: [],
    [currency.pln.id]: [apmType.googlePayAuthNet, apmType.payPal, apmType.adyenBlik, apmType.adyenDotPay, apmType.adyenDropIn],
    [currency.pkr.id]: [],
    [currency.pgk.id]: [],
    [currency.pen.id]: [],
    [currency.pab.id]: [],
    [currency.omr.id]: [],
    [currency.nzd.id]: [apmType.googlePayAuthNet, apmType.braintreePayPal, apmType.payPal, apmType.pproPoli, apmType.adyenPoli, apmType.adyenAfterPay, apmType.adyenDropIn, apmType.klarnaPayments],
    [currency.npr.id]: [],
    [currency.nok.id]: [
        apmType.googlePayAuthNet,
        apmType.payPal,
        apmType.klarnaCheckout,
        apmType.klarnaPayments,
        apmType.adyenVipps,
        apmType.adyenMobilePay,
        apmType.adyenKlarnaPayOverTime,
        apmType.adyenTrustly,
        apmType.adyenKlarnaPayLater,
        apmType.adyenDropIn
    ],
    [currency.nio.id]: [],
    [currency.ngn.id]: [],
    [currency.myr.id]: [apmType.payPal, apmType.pproFpx],
    [currency.mwk.id]: [],
    [currency.mvr.id]: [],
    [currency.mur.id]: [],
    [currency.mru.id]: [],
    [currency.mop.id]: [],
    [currency.mnt.id]: [],
    [currency.mdl.id]: [],
    [currency.mad.id]: [],
    [currency.lyd.id]: [],
    [currency.lkr.id]: [],
    [currency.lbp.id]: [],
    [currency.lak.id]: [],
    [currency.kzt.id]: [],
    [currency.kyd.id]: [],
    [currency.kwd.id]: [],
    [currency.kmf.id]: [],
    [currency.kgs.id]: [],
    [currency.kes.id]: [],
    [currency.jod.id]: [],
    [currency.jmd.id]: [],
    [currency.isk.id]: [],
    [currency.inr.id]: [apmType.payPal],
    [currency.ils.id]: [apmType.payPal],
    [currency.idr.id]: [],
    [currency.huf.id]: [apmType.payPal],
    [currency.htg.id]: [],
    [currency.hrk.id]: [],
    [currency.hkd.id]: [apmType.googlePayAuthNet, apmType.payPal, apmType.nihaoPayAliPay, apmType.nihaoPayUnionPay, apmType.nihaoPayWechatPay],
    [currency.gyd.id]: [],
    [currency.gtq.id]: [],
    [currency.gnf.id]: [],
    [currency.gmd.id]: [],
    [currency.gip.id]: [],
    [currency.ghs.id]: [],
    [currency.gel.id]: [],
    [currency.fkp.id]: [],
    [currency.fjd.id]: [],
    [currency.etb.id]: [],
    [currency.egp.id]: [],
    [currency.dzd.id]: [],
    [currency.dop.id]: [],
    [currency.dkk.id]: [
        apmType.googlePayAuthNet,
        apmType.payPal,
        apmType.klarnaCheckout,
        apmType.klarnaPayments,
        apmType.adyenMobilePay,
        apmType.adyenKlarnaPayOverTime,
        apmType.adyenTrustly,
        apmType.adyenKlarnaPayLater,
        apmType.adyenDropIn
    ],
    [currency.djf.id]: [],
    [currency.czk.id]: [apmType.googlePayAuthNet, apmType.payPal, apmType.pproTrustPay, apmType.adyenTrustly, apmType.adyenDropIn],
    [currency.cve.id]: [],
    [currency.crc.id]: [],
    [currency.cop.id]: [],
    [currency.clp.id]: [apmType.googlePayAuthNet],
    [currency.chf.id]: [apmType.payPal, apmType.klarnaCheckout, apmType.adyenKlarnaPayLater, apmType.klarnaPayments, apmType.adyenKlarnaPayOverTime, apmType.adyenSofort, apmType.adyenDropIn],
    [currency.bzd.id]: [],
    [currency.byn.id]: [],
    [currency.bwp.id]: [],
    [currency.bsd.id]: [],
    [currency.bob.id]: [],
    [currency.bnd.id]: [],
    [currency.bmd.id]: [],
    [currency.bhd.id]: [],
    [currency.bgn.id]: [],
    [currency.bdt.id]: [],
    [currency.bbd.id]: [],
    [currency.bam.id]: [],
    [currency.azn.id]: [],
    [currency.awg.id]: [],
    [currency.ars.id]: [],
    [currency.aoa.id]: [],
    [currency.ang.id]: [],
    [currency.amd.id]: [],
    [currency.all.id]: [],
    [currency.ron.id]: [],
    [currency.sar.id]: [],
    [currency.khr.id]: [],
    [currency.svc.id]: [],
    [currency.aed.id]: [],
    [currency.mzn.id]: [],
    [currency.nad.id]: [],
    [currency.afn.id]: [],
    [currency.bif.id]: [],
    [currency.cdf.id]: [],
    [currency.lrd.id]: [],
    [currency.lsl.id]: [],
    [currency.mga.id]: [],
    [currency.mkd.id]: [],
    [currency.mmk.id]: [],
    [currency.srd.id]: [],
    [currency.tjs.id]: [],
    [currency.btc.id]: [apmType.coinbaseCommerce]
};

const apmToCurrencyMapper = invertObjectWithArrayValues(currencyToApm);

const webhookEnabledGateways = [
    gatewayType.openpay,
    gatewayType.payments_os,
    gatewayType.payments_os_asia_pacific,
    gatewayType.payments_os_colombia,
    gatewayType.payments_os_south_africa,
    gatewayType.payments_os_turkey,
    gatewayType.payments_os_russia,
    gatewayType.payments_os_nigeria,
    gatewayType.payments_os_india,
    gatewayType.payments_os_iyzico,
    gatewayType.reach,
    gatewayType.switch,
    gatewayType.switch_kicc,
    gatewayType.checkout,
    gatewayType.checkout_nas
];

function getDaysToDisputeChargeback(chargebackCycle, cardType) {
    const daysToDispute = {
        1: {
            visa: 30,
            mastercard: 45,
            discover: 45,
            amex: 20
        },
        3: {
            visa: 30,
            mastercard: 45,
            discover: 45,
            amex: 20
        }
    };

    return _.get(daysToDispute, `${chargebackCycle}.${cardType}`, 'Unknown');
}

const reasonCodes = {
    '10.1': 'EMV Liability Shift Counterfeit Fraud',
    '10.2': 'EMV Liability Shift Non - Counterfeit Fraud',
    '10.3': 'Other Fraud – Card Present Environment',
    '10.4': 'Other Fraud – Card Absent Environment',
    '10.5': 'Visa Fraud Monitoring Program',
    '11.1': 'Card Recovery Bulletin',
    '11.2': 'Declined Authorization',
    '11.3': 'No Authorization',
    '12.1': 'Late Presentment',
    '12.2': 'Incorrect Transaction Code',
    '12.3': 'Incorrect Currency',
    '12.4': 'Incorrect Account Number',
    '12.5': 'Incorrect Amount',
    '12.6': 'Duplicate Processing / Paid by Other means',
    '12.7': 'Invalid Data',
    '13.1': 'Merchandise / Services Not Received',
    '13.2': 'Cancelled Recurring',
    '13.3': 'Not As Described or Defective Merchandise / Services',
    '13.4': 'Counterfeit Merchandise',
    '13.5': 'Misrepresentation',
    '13.6': 'Credit Not Processed',
    '13.7': 'Cancelled Merchandise / Services',
    '13.8': 'Original Credit Transaction Not Accepted',
    '13.9': 'Non - Receipt of Cash or Load Transaction Value',
    30: 'Services not provided or merchandise not received',
    41: 'Cancelled recurring transaction',
    75: 'Cardholder does not recognize transaction',
    83: 'Fraud - card absent environment',
    85: 'Credit not processed',
    441: 'Cancelled recurring transaction',
    453: 'Not as described or defective merchandise',
    457: 'Fraudulent multiple transactions',
    460: 'Requested copy illegible or invalid',
    462: 'Counterfeit transaction',
    471: 'Declined authorization',
    472: 'No authorization',
    473: 'Expired card',
    474: 'Late presentment',
    475: 'Cardholder does not recognize transaction',
    476: 'Incorrect transaction code',
    477: 'Non-matching account number',
    480: 'Incorrect transaction amount or account number',
    481: 'Fraud card present environment',
    482: 'Duplicate processing',
    483: 'Fraud - card absent environment',
    485: 'Credit not processed',
    486: 'Paid by other means',
    490: 'Services not rendered - Atm',
    496: 'Transaction exceeds limited amount',
    2000: 'General; Invalid chargeback (incoming only)',
    2001: 'Invalid acquirer reference data on chargeback; documentation was not received or was not required',
    2002: 'Nonreceipt of required documentation to support chargeback',
    2003: 'Correct transaction date provided',
    2004: 'Invalid acquirer reference data on chargeback; documentation was received',
    2005: 'Correct merchant location/description provided',
    2008: 'Issuer authorized transaction',
    2011: 'Credit previously issued',
    2700: 'Chargeback remedied. See corresponding documentation',
    2701: 'Duplicate chargeback',
    2702: 'Past chargeback time limit',
    2703: 'Requested transaction information not received (requires hard ship variance)',
    2704: 'Invalid member message text',
    2705: 'Correct MCC provided',
    2706: 'Authorization advised suspicious',
    2707: 'No authorization required or attempted',
    2708: 'Account was not listed on the applicable warning bulletin as of the transaction date',
    2709: 'Documentation received was illegible',
    2710: 'Scanning error - unrelated documents or partial scan',
    2713: 'Invalid chargeback',
    2870: 'Chip liability shift',
    2871: 'Chip/PIN liability shift',
    4534: 'Duplicate processing',
    4541: 'Automatic payment cancelled by cardholder',
    4553: 'Quality of goods or services',
    4755: 'Goods not received',
    4800: 'First Presentment (FDR code)',
    4801: 'Requested transaction information not received',
    4802: 'Requested/required information illegible or missing',
    4807: 'Warning bulletin file',
    4808: 'Requested/required authorization not obtained',
    4812: 'Account number not on file',
    4831: 'Transaction amount differs',
    4834: 'Duplicate processing',
    4835: 'Card not valid or expired',
    4837: 'No cardholder authorization',
    4840: 'Fraudulent processing of transactions',
    4841: 'Canceled recurring transaction',
    4842: 'Late presentment',
    4846: 'Correct transaction currency code not provided',
    4847: 'Requested/required authorization not obtained and fraudulent transaction',
    4849: 'Questionable merchant activity',
    4850: 'Credit posted as purchase',
    4853: 'Cardholder dispute - defective/not as described',
    4854: 'Cardholder dispute - not elsewhere classified (U.S. only)',
    4855: 'Goods or services not provided',
    4857: 'Card-activated telephone transaction',
    4859: 'Addendum, no-show, or ATM dispute',
    4860: 'Credit not processed',
    4862: 'Counterfeit transaction; magnetic stripe POI fraud',
    4863: 'Cardholder does not recognize - potential fraud (U.S.only)',
    4870: 'Chip liability shift',
    4871: 'Chip/PIN liability shift',
    4900: 'General, invalid chargeback (incoming only)',
    4901: 'Required documentation not received to support prior second presentment/1240',
    4902: 'Documentation received was illegible',
    4903: 'Scanning error - unrelated documents or partial scan',
    4905: 'Invalid acquirer reference data on 2nd presentment; documentation was not received/was not required',
    6005: 'Bank requesting copy of customer receipt for fraud analysis',
    6041: 'Bank requesting copy of customer receipt for fraud analysis',
    7010: 'No cardholder authorization',
    7030: 'No cardholder authorization (card not present environment)',
    8002: 'Credit not processed',
    'F29': 'Fraud - Card not present',
    'R13': 'Inquiry/Misc - No reply'
};

const fraudMapper = {
    R: 'REVIEW',
    D: 'DECLINED',
    A: 'APPROVED',
    E: 'ERRORED'
};
const fraudStatuses = _.invert(fraudMapper);

const transactionStatusChangeSource = {
    EMVIO: 'EMVIO',
    KOUNT: 'KOUNT'
};

const usageTypes = {
    accountUpdater: 10,
    tokenCount: 20,
    payment: 30,
    apm: 40,
    payout: 50
};
const usageTypesMapper = _.invert(usageTypes);

const accountUpdaterUpdateTypes = {
    cardNumber: 10,
    cardExpiration: 20,
    accountClosed: 30,
    contactCardholder: 40,
    deleteCard: 50
};
const accountUpdaterUpdateTypesMapper = _.invert(accountUpdaterUpdateTypes);

const paymentSubTypes = {
    cardSave: 10,
    process: 20,
    void: 30,
    capture: 40,
    refund: 50,
    credit: 60,
    process3ds: 70,
    deleteCard: 80
};

const paymentSubTypesMapper = _.invert(paymentSubTypes);

const apmSubTypes = {
    process: 20,
    void: 30,
    capture: 40,
    refund: 50,
    zeroAuth: 60
};
const apmSubTypesMapper = _.invert(apmSubTypes);

const payoutSubTypes = {
    payout: 10,
    spendback: 20
};
const payoutSubTypesMapper = _.invert(payoutSubTypes);

const chargebackSource = {
    md021: 'md021',
    sd071v: 'sd071v',
    sd071mc: 'sd071mc',
    sd119mc: 'sd119mc',
    sd119v: 'sd119v',
    sd206: 'sd206',
    sd209: 'sd209',
    sd430b: 'sd430b'
};

const paymentRecoveryProviderTypes = {
    flexpay: 10
};

const paymentRecoveryProviderTypesMapper = _.invert(paymentRecoveryProviderTypes);

const paymentRecoveryStatusTypes = {
    disabled: 10,
    inProgress: 20,
    scheduled: 30,
    unrecoverable: 40,
    recovered: 50,
    capture: 70,
    void: 80,
    refund: 90
};

const paymentRecoveryStatusTypesMapper = _.invert(paymentRecoveryStatusTypes);

const retryEngineTypes = {
    flexpay: 10,
    accountUpdater: 20
};

const retryEngineTypesMapper = _.invert(retryEngineTypes);

const processingOptionsPaymentTypes = {
    initialScheduled: 10,  //first in a series, VISA requirement
    scheduled: 20,  //series
    initialUnscheduled: 30,    //first and NOT part of a series, VISA requirement
    unscheduledCit: 40,    //customer initiated
    unscheduledMit: 50,    //merchant initiated
    initialMoto: 60,   //merchant on demand
    moto: 70
};
const processingOptionsPaymentTypesMapper = _.invert(processingOptionsPaymentTypes);

const accountAgreementStatus = {
    OUTSTANDING: 'OUTSTANDING',
    PAPER: 'PAPER',
    COMPLETE: 'COMPLETE',
    NA: 'NA'
};

const accountTypes = {
    MERCHANT: 'MERCHANT',
    PARTNER: 'PARTNER',
    RESELLER: 'RESELLER',
    INTERNAL: 'INTERNAL'
};

const payoutProvider = {
    interchecks: 10,
    hyperwallet: 20,
    payquicker: 30,
    nexio: 40,
    masspay: 50,
    nomad: 60
};

const payoutProviderMapper = _.invert(payoutProvider);

const payoutStatus = {
    pendingProviderAction: 10,
    pendingMerchantAction: 11,
    pendingRecipientAction: 12,
    completed: 20,
    expired: 30,
    canceled: 40,
    returned: 50,
    failed: 90
};

const payoutStatusMapper = _.invert(payoutStatus);

const transferStatus = {
    available: 10,
    paid: 20,
    error: 90
};

const transferStatusMapper = _.invert(transferStatus);

const spendbackStatus = {
    pending: 10,
    completed: 20,
    review: 30,
    expired: 40,
    canceled: 50,
    failed: 90
};

const spendbackStatusMapper = _.invert(spendbackStatus);

const reseller = {
    nexio: 10,
    nexioFake: 11,
    cora: 20,
    bestNotes: 30,
    carePaths: 40,
    cccCorp: 50,
    claimpower: 60,
    ehrYourWay: 70,
    luxuryRes: 80,
    reLiMed: 90,
    resNexus: 100
};

const resellerMapper = _.invert(reseller);

const merchantApplicationSourceType = {
    merchantApplicationPostback: 10,
    cmcMerchant: 20
};

const merchantApplicationSourceTypeMapper = _.invert(merchantApplicationSourceType);

const pciFields = {
    ['cvv']: [
        'cvv',
        'cvv2',
        'cvc',
        'ccv',
        'ssc',
        'security code',
        'security_code',
        'securityCode'
    ]
};

module.exports = {
    mapType,
    cycleTypes,
    addToAllCurrencies,
    invertObjectWithArrayValues,
    accountUpdaterModes,
    accountUpdaterModesMapper,
    chargebackCycleTypes,
    chargebackCycleTypesMapper,
    cardTypes,
    cardClasses,
    cardClassesMapper,
    cardTypesMapper,
    merchantProcessorType,
    merchantProcessorTypeMapper,
    threeDSType,
    threeDSTypeMapper,
    processorPrefixes,
    findProcessorWithMatchingPrefix,
    processorsWithDisputeEnabled,
    paymentMethodsFormatted,
    processMethod,
    processMethodMapper,
    installmentProviders,
    installmentProvidersMapper,
    transactionStatus,
    transactionStatusMapper,
    paymentStatusToTransactionStatus,
    transactionType,
    transactionTypeMapper,
    pluginType,
    pluginTypeMapper,
    batchStatus,
    batchStatusMapper,
    achDetailType,
    achDetailTypeMapper,
    kountThresholds,
    paymentMethodToGateway,
    gatewayToPaymentMethodMapper,
    currencyToGateway,
    gatewayToCurrencyMapper,
    currencyToApm,
    apmToCurrencyMapper,
    webhookEnabledGateways,
    getDaysToDisputeChargeback,
    reasonCodes,
    fraudMapper,
    fraudStatuses,
    transactionStatusChangeSource,
    usageTypes,
    usageTypesMapper,
    accountUpdaterUpdateTypes,
    accountUpdaterUpdateTypesMapper,
    paymentSubTypes,
    paymentSubTypesMapper,
    apmSubTypes,
    apmSubTypesMapper,
    payoutSubTypes,
    payoutSubTypesMapper,
    chargebackSource,
    paymentRecoveryProviderTypes,
    paymentRecoveryProviderTypesMapper,
    paymentRecoveryStatusTypes,
    paymentRecoveryStatusTypesMapper,
    retryEngineTypes,
    retryEngineTypesMapper,
    processingOptionsPaymentTypes,
    processingOptionsPaymentTypesMapper,
    accountAgreementStatus,
    accountTypes,
    payoutProvider,
    payoutProviderMapper,
    payoutStatus,
    payoutStatusMapper,
    transferStatus,
    transferStatusMapper,
    spendbackStatus,
    spendbackStatusMapper,
    reseller,
    resellerMapper,
    merchantApplicationSourceType,
    merchantApplicationSourceTypeMapper,
    pciFields
};
